import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";

class AdminPagarmeInvoicesModule extends HttpFactory {
  async getInvoices(providerSubscriptionId: string): Promise<any[]> {
    return await this.get<any[]>(
      `${ENDPOINTS.ADMIN.PAYMENT.PAGARME_PROXY.INVOICES}`,
      { provider_subscription_id: providerSubscriptionId },
    );
  }

  async getInvoice(invoiceId: string): Promise<any[]> {
    return await this.get<any[]>(
      `${ENDPOINTS.ADMIN.PAYMENT.PAGARME_PROXY.INVOICES}${invoiceId}`,
    );
  }
}

export { AdminPagarmeInvoicesModule };
